import React, { useRef } from 'react';
import cn from 'clsx';
import { TabIndex } from '../../utils/tabIndexes';
import { DH } from '../../utils/DataHook';
import s from './styles.scss';

export interface IContinueButtonProps {
  onClick: () => void;
  label: string;
  ariaLabel: string;
  disabled?: boolean;
}

const ContinueButton = ({ onClick, label, ariaLabel, disabled = false }: IContinueButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <button
      ref={buttonRef}
      onClick={() => {
        onClick();
        buttonRef.current?.blur();
      }}
      className={cn({
        [s.continueButton]: true,
        [s.disabled]: disabled,
      })}
      data-hook={DH.ProceedButton}
      aria-label={ariaLabel}
      tabIndex={disabled ? TabIndex.None : TabIndex.ContinueButton}
      disabled={disabled}
      aria-disabled={disabled}
    >
      {label}
    </button>
  );
};

export default ContinueButton;
